// A tela de orçamento usa o conjunto compartilhado com o editor de proposta
// (EditorDocumento.design.js). Este arquivo existe para a tela ter o seu
// `.design.js` por convenção e para acrescentar tokens só dela, se surgirem.
import { DOCUMENTO_DESIGN } from '../EditorDocumento.design';

export const ORCAMENTO_DESIGN = DOCUMENTO_DESIGN;
